import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { HostLegacy } from "@silvertours/front-legacy-entities";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { Container } from "./NewsletterRegistration.styles";
var NewsletterSignupSuccess = function(param) {
    var showTitle = param.showTitle;
    var t = useTranslations("features.newsletterRegistrationLegacy.newsletterRegistration");
    var formatImage = HostLegacy.useHost().formatImage;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showTitle && /*#__PURE__*/ _jsx(UiLegacy.SectionTitle, {
                children: t("newsletterSuccessTitle")
            }),
            /*#__PURE__*/ _jsxs(Container, {
                alignCenter: true,
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: formatImage("/bm/global/graphic/image/flexsite/nl_success.svg"),
                        alt: "",
                        width: 115,
                        height: 132
                    }),
                    t("newsletterSuccessText")
                ]
            })
        ]
    });
};
export { NewsletterSignupSuccess };
